document.addEventListener('DOMContentLoaded', function () {
  // === Sticky Tabs on Scroll ===
  const tabs = document.querySelector('.fit-tabs');
  const tabbedSection = document.querySelector('.fit-guide.tabbed-version');

  if (tabs && tabbedSection) {
    const observer = new IntersectionObserver(
      function (entries) {
        if (!entries[0].isIntersecting) {
          tabs.classList.add('sticky');
        } else {
          tabs.classList.remove('sticky');
        }
      },
      {
        rootMargin: '-80px 0px 0px 0px',
        threshold: 0,
      }
    );
    observer.observe(tabbedSection);
  }

  // === Scroll to top of tabbed section when tab clicked ===
  // const tabButtons = document.querySelectorAll('.tab');
  // tabButtons.forEach((tab) => {
  //   tab.addEventListener('click', function () {
  //     const sectionTop = tabbedSection.getBoundingClientRect().top + window.pageYOffset;
  
  //     window.scrollTo({
  //       top: sectionTop - 80, // adjust if you have sticky header
  //       behavior: 'smooth',
  //     });
  //   });
  // });

  // === Fit logic ===
  const select = document.getElementById('product-type-select');
  const genderTabs = document.querySelectorAll('.fit-guide__gender-tab');

  let currentGender = 'men'; // Default

  const productTypeToFitMap = {
    "Classico SS jersey": "firm",
    "Vest": "firm",
    "rain jacket": "firm-relaxed",
    "Principale SS jersey": "tight",
    "Principale LS jersey": "tight",
    "Winter LS jersey": "firm-relaxed",
    "tech tee": "firm-relaxed",
    "Bib shorts": "bibs",
    "Longs": "longs",
    "custom jersey regular": "firm",
    "custom jersey club": "club"
  };

  const chartSections = document.querySelectorAll('[data-fit-chart]');
  const peopleSections = document.querySelectorAll('[data-fit-people]');

  function updateFitContent(productType) {
    const selectedFit = productTypeToFitMap[productType];

    chartSections.forEach(section => {
      const match = section.dataset.fitChart === selectedFit && section.dataset.gender === currentGender;
      section.style.display = match ? 'block' : 'none';
    });

    peopleSections.forEach(section => {
      const match = section.dataset.fitPeople === selectedFit && section.dataset.gender === currentGender;
      section.style.display = match ? 'block' : 'none';
    });

    const aboutSection = document.getElementById('about-our-fits');
    if (aboutSection) {
      const hideFits = ['bibs', 'longs'];
      aboutSection.style.display = hideFits.includes(selectedFit) ? 'none' : 'block';
    }
  }

  // Gender tab toggle
  if (genderTabs.length) {
    genderTabs.forEach(tab => {
      tab.addEventListener('click', function () {
        genderTabs.forEach(t => t.classList.remove('active'));
        this.classList.add('active');
        currentGender = this.dataset.gender;
        if (select) updateFitContent(select.value);
      });
    });
  }

  if (select) {
    select.addEventListener('change', function () {
      updateFitContent(this.value);
    });

    // Trigger on load
    updateFitContent(select.value);
  }
});
